

import __layout_0 from '/build/src/packages/hoppscotch-app/src/layouts/default.vue'
export const layouts = {
'default': __layout_0,
'empty': () => import('/build/src/packages/hoppscotch-app/src/layouts/empty.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
